import React, { Component } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { Row, Col, Switch } from 'hljd'
import style from './style.module.less'
import SortModal from './sortModal'
import CloseModal from './closeModal'
import { hashHistory } from 'react-router'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import Store from './store'
const store = new Store()
@observer
export default class extends Component {
  componentDidMount() {
    store.getPropertyList()
  }

  showCloseModal = (e, param) => {
    e.stopPropagation()
    store.showCloseModal(param)
  }

  handleClick = (hidden, id) => {
    if (hidden != '0') {
      return
    }
    if (id == 1000) {
      hashHistory.push('/localMerchant/jiaMengGoods/weddingSupervise')
      return
    }
    hashHistory.push('/localMerchant/jiaMengGoods/weddingPhoto/' + id)
  }
  render() {
    const list = toJS(store.list)
    return (
      <div className={style.jiamengGoosWrap}>
        <p className="top-tip">
          一站式备婚中心的核心优势：多品类一站式服务，在一家店里可以搞定婚礼的多数服务。新人少跑几趟，商家获得更多成单机会~
        </p>
        <div className="title-and-sort clearfix">
          <span>全部商品</span>
          <span onClick={() => store.setStoreData('sortModalVisible', true)}>
            调整品类顺序
          </span>
        </div>
        <Row>
          {list.map((item, index) => {
            const itemCount = item.count || {}
            return (
              <Col key={item.id} span={6} className="goods-item-wrap">
                <div
                  className={`goods-item ${item.hidden == '0' ? 'active' : ''}`}
                  onClick={() =>
                    this.handleClick(item.hidden, item.property.id)
                  }
                >
                  <div className="goods-item-name">{item.property.name}</div>
                  {store.sortListLen > 1 ? (
                    <div
                      className="close-btn"
                      onClick={e =>
                        this.showCloseModal(e, {
                          id: item.property.id,
                          name: item.property.name,
                          recordId: item.id
                        })
                      }
                    >
                      <CloseOutlined style={{ color: '#fff' }} />
                    </div>
                  ) : null}
                  <div className="goods-item-info">
                    <div className="pos-box">
                      <div className="info-common clearfix">
                        {item.kind == '2' ? null : (
                          <span className="fl">
                            自有商品：{itemCount.self || 0}
                          </span>
                        )}
                        <span className={item.kind == '2' ? '' : 'fr'}>
                          婚礼纪直供：{itemCount.supply || 0}
                        </span>
                      </div>
                      {item.hidden == '0' ? (
                        itemCount.wait || itemCount.failure ? (
                          <div className="info-common info-special clearfix">
                            <span className="fl">
                              审核中：{itemCount.wait || 0}
                            </span>
                            <span className="fr">
                              审核不通过：{itemCount.failure || 0}
                            </span>
                          </div>
                        ) : null
                      ) : (
                        <Switch
                          checkedChildren="开启"
                          unCheckedChildren="关闭"
                          onChange={() => store.changeProperty(item.id, '2')}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            )
          })}
        </Row>
        <SortModal store={store} />
        <CloseModal store={store} />
      </div>
    )
  }
}
